// extracted by mini-css-extract-plugin
export var spin = "styles-module--spin--6d766";
export var spinner = "styles-module--spinner--fa2f7";